import { Button } from "@nextui-org/react";
import React from "react";

import Trans from "@/components/Trans/Trans";

import { PersonalInfoSummaryProps } from "./types";

const PersonalInfoSummary = ({ country, state, postal_code, first_name, last_name, onChangeButtonClick }: PersonalInfoSummaryProps) => {
  return (
    //we'll display in short form the info as a summary
    <div className="flex flex-row justify-between items-center">
      <div className="flex flex-col gap-1">
        <span className="text-sm font-semibold">
          {first_name} {last_name}, {state} {country} {postal_code}
        </span>
      </div>
      <span className="text-sm font-semibold">
        {" "}
        <Button radius="full" variant="bordered" onClick={onChangeButtonClick} aria-label="change">
          <Trans i18nKey="subscription:checkout.personalInfo.change" />
        </Button>
      </span>
    </div>
  );
};

export default PersonalInfoSummary;
